export const processDocumentsMixin = {
  methods: {
    processDocuments (row) {
      let concatDocTitle = ''
      let concatDocName = ''
      let concatDocForwarder = ''
      let concatDocDecisionNumber = ''
      let concatDocCustom = ''
      let concatDocExecutive = ''
      let concatDocDecision = ''
      let concatDocPreparationDate = ''
      let comissionSignature = null
      let decisionSignature = null
      for (let i = 0; i < row.item.documents.length; i++) {
        const docHtml = row.item.documents[i].html
        try {
          let doc = null
          if (window.DOMParser) {
            const parser = new DOMParser()
            doc = parser.parseFromString(docHtml, 'text/html')
          }
          let title = doc.getElementById('documentTitle')
          if (!title && row.item.documents[i].type.toLowerCase() === 'billoflading.html.cfg.xml') {
            title = 'Коносамент'
          } else if (!title && row.item.documents[i].type.toLowerCase() === 'armti-express.cfg.xml') {
              title = 'ПТД для экспресс-грузов'
          } else if (!title && row.item.documents[i].type.toLowerCase() === 'notifgtdregistration.html.cfg.xml') {
              title = 'Уведомление о регистрации'
          } else if (!title && row.item.documents[i].type.toLowerCase() === 'expresscargodeclarationcustommark.html.cfg.xml') {
              title = 'Решение таможенного органа'
          } else if (title) {
            title = title.innerHTML
          } else {
            title = 'Таможенный формат xml'
          }
          if (title.length > 0) {
            row.item.documents[i].documentName = title
          }
          if (row.item.documents[i].type.toLowerCase() === 'armti-commissionshipment.cfg.xml') { // Поручение
            concatDocTitle = title + ' с решением'
            concatDocName = doc.getElementById('NamePersonSignature')
            if (concatDocName) concatDocName = concatDocName.innerHTML
            concatDocForwarder = doc.getElementById('Forwarder')
            if (concatDocForwarder) concatDocForwarder = concatDocForwarder.innerHTML

            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              comissionSignature = {
                info: doc.getElementById('signature-info').innerHTML,
                owner: doc.getElementById('signature-owner').innerHTML,
                issued: doc.getElementById('signature-issued').innerHTML,
                valid: doc.getElementById('signature-valid').innerHTML
              }
            }
            doc.getElementsByClassName('signature')[0].remove()
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.general-information { font-size: 9pt; } ' +
              'div.pagebook { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagebook table { font-size: 9pt; } ' +
              'div.pagelandscape { padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagelandscape table { font-size: 8pt; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 9pt; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; } ' +
              'div.title, tr.title td { font-weight: bold; margin-top: 5px; margin-bottom: 5px; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray; white-space: normal; } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray; white-space: normal; } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray; white-space: normal; } ' +
              'tr td.declnumber { word-break: break-all; min-width: 80px; width: 80px; } ' +
              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +
              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML

            const parserForPdf = new DOMParser()
            let docForPdf = parserForPdf.parseFromString(row.item.documents[i].htmlForPdf, 'text/html')
            const pagelandscape = docForPdf.getElementsByClassName('pagelandscape')[0]
            pagelandscape.parentNode.removeChild(pagelandscape)
            row.item.documents[i].htmlForPdfCommissionShipment = docForPdf.getElementsByTagName('html')[0].outerHTML

            const mergedDocumentXml = row.item.documents.filter((document) => {
              return document.type.toLowerCase() === ('COMMISSIONSHIPMENT.cfg.xml').toLowerCase()
            })
            row.item.documents[i].mergedDocumentXml = (mergedDocumentXml.length > 0) ? mergedDocumentXml[0].xml : ''
          } else if (row.item.documents[i].type.toLowerCase() === 'commissionshipmentdecision.html.cfg.xml') { // Решение
            concatDocDecisionNumber = title
            concatDocCustom = doc.getElementById('customs_department')
            if (concatDocCustom) concatDocCustom = concatDocCustom.innerHTML
            concatDocExecutive = doc.getElementById('executive')
            if (concatDocExecutive) concatDocExecutive = concatDocExecutive.innerHTML
            concatDocDecision = doc.getElementById('decision')
            if (concatDocDecision) concatDocDecision = concatDocDecision.innerHTML
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              doc.getElementById('signature-info').setAttribute('style', 'margin-top: 10px')
              doc.getElementById('signature-info').innerHTML = '<b>Решение по поручению подписано усиленной квалифицированной электронной подписью: </b>'
              decisionSignature = {
                info: doc.getElementById('signature-info').innerHTML,
                certificate: doc.getElementById('signature-certificate').innerHTML,
                owner: doc.getElementById('signature-owner').innerHTML,
                issued: doc.getElementById('signature-issued').innerHTML,
                valid: doc.getElementById('signature-valid').innerHTML
              }
            }
            concatDocPreparationDate = this.getPreparationDate(row.item.documents[i].preparation_date)
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.page { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; padding-bottom: 5mm; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 9pt; } ' +
              '.marg-top { margin-top: 5mm; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; font-size: 9pt; } ' +
              '.graph { font-size: 10pt; } ' +
              '.value { border-bottom: solid 1px black; } ' +
              'div.title, tr.title td { font-weight: bold; } ' +
              '.bordered { border-collapse: collapse; } ' +
              'td.graphMain { vertical-align: top; } ' +
              'td.value.graphMain { vertical-align: bottom; }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray } '
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].type.toLowerCase() === 'billoflading.html.cfg.xml') { // Коносамент
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.page { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; padding-bottom: 5mm; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; } ' +
              'div.title, tr.title td { font-weight: bold; margin-top: 5px; margin-bottom: 5px; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray; white-space: normal; } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray; white-space: normal; } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray; white-space: normal; } ' +
              'tr td.declnumber { word-break: break-all; min-width: 80px; width: 80px; } ' +
              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +
              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].type.toLowerCase() === 'goodsdecision.html.cfg.xml') { // Окончательное решение при перевозке морским транспортом
            const hasSignature = doc.getElementsByClassName('signature')[0]
            if (hasSignature) {
              doc.getElementById('signature-info').setAttribute('style', 'margin-top: 10px')
              doc.getElementById('signature-info').innerHTML = '<b>Окончательное решение по судну подписано усиленной квалифицированной электронной подписью: </b>'
            }
            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].type.toLowerCase() === 'armti-express.cfg.xml') { // РЭГ: ПТД для экспресс-грузов
            concatDocTitle = title + ' с решением'
            concatDocName = doc.getElementById('NamePersonSignature')
            if (concatDocName) concatDocName = concatDocName.innerHTML
            concatDocForwarder = doc.getElementById('Forwarder')
            if (concatDocForwarder) concatDocForwarder = concatDocForwarder.innerHTML

            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.general-information { font-size: 9pt; } ' +
              'div.pagebook { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagebook table { font-size: 9pt; } ' +
              'div.pagelandscape { padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagelandscape table { font-size: 8pt; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 9pt; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; } ' +
              'div.title, tr.title td { font-weight: bold; margin-top: 5px; margin-bottom: 5px; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray; white-space: normal; } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray; white-space: normal; } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray; white-space: normal; } ' +
              'tr td.declnumber { word-break: break-all; min-width: 80px; width: 80px; } ' +
              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +
              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          } else if (row.item.documents[i].type.toLowerCase() === 'notifgtdregistration.html.cfg.xml' ||
              row.item.documents[i].type.toLowerCase() === 'expresscargodeclarationcustommark.html.cfg.xml') { // РЭГ: Уведомление о регистрации, РЭГ: Решение таможенного органа
            concatDocTitle = title + ' с решением'
            concatDocName = doc.getElementById('NamePersonSignature')
            if (concatDocName) concatDocName = concatDocName.innerHTML
            concatDocForwarder = doc.getElementById('Forwarder')
            if (concatDocForwarder) concatDocForwarder = concatDocForwarder.innerHTML

            row.item.documents[i].htmlAfterProcessing = doc.getElementsByTagName('html')[0].outerHTML
            doc.getElementsByTagName('style')[0].innerHTML = 'div.general-information { font-size: 9pt; } ' +
              'div.pagebook { padding-top: 5mm; padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagebook table { font-size: 9pt; } ' +
              'div.pagelandscape { padding-left: 5mm; padding-right: 5mm; font-size: 9pt; } ' +
              'div.pagelandscape table { font-size: 8pt; } ' +
              'div.signature { white-space: normal; margin: 10px auto; margin-top: 6pt; margin-bottom: 6pt; background: #ffffff; font-family: Arial; font-size: 9pt; } ' +
              'table { width: 100%; border: 0; empty-cells: show; border-collapse: collapse; margin-top: 1px; } ' +
              'div.title, tr.title td { font-weight: bold; margin-top: 5px; margin-bottom: 5px; } ' +
              'tr td { padding: 1px }' +
              'tr td.bordered { border-top: 1px solid gray; border-right: 1px solid gray; white-space: normal; } ' +
              'tr td.bordered:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray; white-space: normal; } ' +
              'tr:last-child td.bordered { border-bottom: 1px solid gray; white-space: normal; } ' +
              'tr td.declnumber { word-break: break-all; min-width: 80px; width: 80px; } ' +
              'tr td.value_b { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value_b:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value_b { border-bottom: 1px solid gray } ' +
              'tr td.value { border-top: 1px solid gray; border-right: 1px solid gray } ' +
              'tr td.value:first-child { border-top: 1px solid gray; border-right: 1px solid gray; border-left: 1px solid gray } ' +
              'tr:last-child td.value { border-bottom: 1px solid gray } ' +
              'td.graphMain { vertical-align: top; }' +
              'td.value.graphMain { vertical-align: bottom; }'
            row.item.documents[i].htmlForPdf = doc.getElementsByTagName('html')[0].outerHTML
          }
        } catch (e) {
          throw new Error('Ошибка при обработке документа html. ' + (e.message || e))
        }
      }
      this.getMergedDocument(row, row.item.pid, concatDocTitle, concatDocName, concatDocForwarder, concatDocDecisionNumber, concatDocCustom, concatDocExecutive, concatDocDecision, concatDocPreparationDate, comissionSignature, decisionSignature)
    },
    getPreparationDate (date) {
      return this.moment(date).format('YYYY-MM-DD HH:mm')
    },
    getMergedDocument (row, packageId, title, name, forwarder, decisionNum, custom, executive, decision, date, comissionSignature, decisionSignature) {
      if ((row.item.status === 266) || (row.item.status === 272) || (row.item.status === 273) || (row.item.status === 274) || (row.item.status === 275) || (row.item.status === 267) || (row.item.status === 268)) {
        const hasForwarder = forwarder ? '<span>' + forwarder + ', ' + '</span>' : ''
        const hasName = name ? '<span>' + name + '</span>' : ''
        const additionalTable = '<table class="bordered w190"><tbody><tr>' +
          '<td style="width: 50%" class="graphMain bordered">' +
          '<div>Поручение подготовил: ' +
          hasForwarder +
          hasName +
          '</div>' +
          '<div style="white-space: normal; margin-top: 10px;"><b>Поручение подписано электронной подписью:</b></div>' +
          '<div style="white-space: normal;">' + comissionSignature.owner + '</div>' +
          '<div style="white-space: normal;">' + comissionSignature.issued + '</div>' +
          '<div style="white-space: normal;">' + comissionSignature.valid + '</div>' +
          '</td>' +
          '<td style="width: 50%" class="graphMain bordered">' +
          '<div><b>' + decisionNum + '</b></div>' +
          '<div>Таможенный пост: ' + custom + '</div>' +
          '<div>Принятое решение: ' + decision + '</div>' +
          '<div>Дата решения: ' + date + '</div>' +
          '<div>Решение принял: ' + executive + '</div>' +
          '<div style="white-space: normal; margin-top: 10px;"><b>Решение по поручению подписано усиленной квалифицированной электронной подписью:</b></div>' +
          '<div style="white-space: normal;">' + decisionSignature.certificate + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.owner + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.issued + '</div>' +
          '<div style="white-space: normal;">' + decisionSignature.valid + '</div>' +
          '</td></tr></tbody></table>'

        let docForView = null
        let docForPdf = null
        const CommissionShipment = row.item.documents.filter((document) => {
          return document.type.toLowerCase() === ('armti-CommissionShipment.cfg.xml').toLowerCase()
        })
        const mergedDocumentXml = row.item.documents.filter((document) => {
          return document.type.toLowerCase() === ('COMMISSIONSHIPMENT.cfg.xml').toLowerCase()
        })
        const CommissionShipmentDecision = row.item.documents.filter((document) => {
          return document.type.toLowerCase() === ('CommissionShipmentDecision.html.cfg.xml').toLowerCase()
        })
        if (window.DOMParser) {
          const parserForView = new DOMParser()
          const parserForPdf = new DOMParser()
          docForView = parserForView.parseFromString(CommissionShipment[0].htmlAfterProcessing, 'text/html')
          docForPdf = parserForPdf.parseFromString(CommissionShipment[0].htmlForPdf, 'text/html')
          const elem1 = document.createElement('div')
          elem1.setAttribute('class', 'pagebook')
          docForView.getElementsByTagName('body')[0].append(elem1)
          docForView.getElementsByClassName('pagebook')[1].innerHTML = additionalTable
          const generalInformation = docForPdf.getElementsByClassName('general-information')[0]
          const pagelandscape = docForPdf.getElementsByClassName('pagelandscape')[0]
          pagelandscape.parentNode.removeChild(pagelandscape)
          row.item.documents[row.item.documents.length] = {
            documentName: title,
            htmlForPdf: docForPdf.getElementsByTagName('html')[0].outerHTML,
            additionalTable: additionalTable,
            generalInformation: generalInformation,
            mergedDocumentXml: (mergedDocumentXml.length > 0) ? mergedDocumentXml[0].xml : '',
            htmlAfterProcessing: docForView.getElementsByTagName('html')[0].outerHTML,
            pid: packageId,
            xml: CommissionShipmentDecision[0].xml,
            html: docForView.getElementsByTagName('html')[0].outerHTML
          }
        }
      }
    }
  }
}
